export const exportSingleSlide = `
  mutation ExportSingleSlide($input: ExportSingleSlideInput!) {
    exportSingleSlide(input: $input)
  }
`;
